module.exports = __webpack_public_path__ + "img/landing-page3.a8d7bab2.jpg";